import { FC } from "react"
import { Box, SxProps, Theme } from "@mui/material"

export interface OnlineDotProps {
  isOnline: boolean
  sx?: SxProps<Theme>
}

export const OnlineDot: FC<OnlineDotProps> = ({ isOnline, sx }) => (
  <Box
    component="span"
    aria-label={isOnline ? "онлайн" : "офлайн"}
    role="img"
    sx={{
      display: "inline-block",
      width: 10,
      height: 10,
      borderRadius: "50%",
      bgcolor: isOnline ? "success.main" : "grey.400",
      flexShrink: 0,
      ...sx,
    }}
  />
)
